import { SignUpType } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { IStepper } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/signupStepper";
import { signUpSteps } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/signUpSteps";
import { Step } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

export type SignUpStepsStore = {
  currentStep: Step;
  allSteps: Step[];
  signUpType: SignUpType;
  stepper: IStepper;
};

const { useStore: useSignUpStepsStore, Provider: SignUpStepsProvider } =
  createContextStore<SignUpStepsStore>(
    {
      currentStep: Step.PERSONAL_INFO,
      allSteps: signUpSteps,
      signUpType: SignUpType.AUTO,
      stepper: () => Step.PERSONAL_INFO,
    },
    { name: "SignUpStepsStore" }
  );

export { useSignUpStepsStore, SignUpStepsProvider };
